import { mixed as yupMixed } from 'yup'
import moment from 'moment'

export const momentDateSchema = yupMixed()
  .test('is-moment', 'Formato de data invalido', value => moment.isMoment(value))
  .test('is-valid', 'Data invalida', value => value?.isValid?.())
  .required('Date is required')
